import { AutopaySettings } from '@pesto/features/src/UserProfile/components/AutopaySettings';
import { toAutopayValues } from '@pesto/features/src/UserProfile/utils/toAutopayValues';

import { useGetLoanAutoPaySettingsQuery } from '../../../__generated__/graphql/api';

interface LoanAutopaySettingsProps {
  loanId: string;
}

export const LoanAutopaySettings = ({ loanId }: LoanAutopaySettingsProps) => {
  const { data, loading } = useGetLoanAutoPaySettingsQuery({
    variables: { loanId },
    skip: !loanId,
  });

  return <AutopaySettings settings={toAutopayValues(data?.loanAutoPaySettings)} loading={loading} readOnly />;
};
